import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import WizardButton from '../WizardButton';
import WizardNavigation from '../WizardNavigation';
import Aux from '../../../hoc/Aux';
import WizardStandardHeader from '../WizardStandardHeader';
import WizardStandardSubHeader from '../WizardStandardSubHeader';
import * as actions from '../../../store/actions/index';
import { useTranslation } from 'react-i18next';
import {Link } from "react-router-dom";
import { ROUTES } from '../../../routes';
import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux';
import SchottForm from './WizardStepCountry/SchottForm';

const wizardStepCountry = (props) => {

  if (props.currentStep !== 'country') {
    return null;
  }

  const { t } = useTranslation();
  const dispatch = useDispatch();


  const isAuthenticated = useSelector(state => state.auth.token !== null);

  const onSelectCountryDE = useCallback(
      () => dispatch(actions.wizardSelectCountry('de')),
      [dispatch]
    )

  const onSelectCountryEU = useCallback(
      () => dispatch(actions.wizardSelectCountry('eu')),
      [dispatch]
    )

  const infoBoxCss = {
    backgroundColor: "#fbf1e0",
    height: "auto"}

  return(

    <Aux>
      <WizardStandardHeader>
        <WizardNavigation />
      </WizardStandardHeader>

      <div className="row justify-content-center content-list-head">
        <div className="col-lg-11 col-xl-11">
          <WizardStandardSubHeader
            display={true}
            title={t('wizard.steps.country.title')}
            modalTitle={ t('wizard.steps.country.modaltitle') }
            modalTextToken={ 'wizard.steps.country.infotext' } />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-11 col-xl-11 pb-5">
          <div className="row">
            <WizardButton key={'de'} title={ t('wizard.steps.country.values.de.long') } onClick={onSelectCountryDE} dividerEnabled={true}/>
            <WizardButton key={'eu'} title={ t('wizard.steps.country.values.eu.long') } onClick={onSelectCountryEU} dividerEnabled={true}/>
          </div>
        </div>

        <SchottForm />

        { (!isAuthenticated) ?
        <div className="col-lg-11 col-xl-11 px-3 ">
          <div className="row">
            <div className="col-12 col-md-10 p-3 wizzard-btn " style={infoBoxCss}>
              <Trans i18nKey="wizard.country.linkcontent_to_user_manual" >
                Anfangstext hier <Link to={{pathname: ROUTES.TO_HELP, hash: "2" }}>Linktext</Link>.
              </Trans>
            </div>
          </div>
        </div>
        : null
        }

        <div className="col-lg-11 col-xl-11 px-3 ">
          <div className="row">
            <div className="col-12 col-md-10 p-3 wizzard-btn " style={infoBoxCss}>
              <Trans i18nKey="wizard.country.info" >
                Anfangstext hier <Link to={ROUTES.TO_HELP}>Linktext</Link>.
              </Trans>
            </div>
          </div>
        </div>
      </div>
    </Aux>
 );
};

export default wizardStepCountry;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepCountry.js